
import { apiHelper } from "../apiHelper/apiHelper";
import { formHelper } from "../apiHelper/formHelper";
import {
  createProductRequest,
  createProductSuccess,
  createProductFailure,
  deleteProductRequest,
  deleteProductSuccess,
  deleteProductFailure,
} from "../slices/productSlices";

// ========================== NEW API HANDLER =================

// get Crop list

// create Regin
export const handleCreateProduct = async (formData, dispatch) => {

  const endPoint = "product/create";
  const method = "POST";
  const state1 = createProductRequest;
  const state2 = createProductSuccess;
  const state3 = createProductFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await formHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// delete Product
export const handleDeleteProduct = (productId) => async (dispatch) => {
  const endPoint = `product/products/${productId}`;  // Supplier ID is appended to the endpoint
  const method = "DELETE";  // Use DELETE method to remove the supplier
  
  const state1 = deleteProductRequest; // Request state action (loading)
  const state2 = deleteProductSuccess; // Success state action
  const state3 = deleteProductFailure; // Failure state action
  const isToast = false; // Toast disabled (can be enabled if you wish)
  const isFile = false; // No file upload involved
  const isToken = true; // Include authentication token

  // Call apiHelper, passing dispatch correctly
  await apiHelper(
    endPoint,
    method,
    null,  // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,  // Ensure dispatch is passed properly
    isFile,
    isToast,
    isToken
  );
};